import React from "react";
import { FormField } from "../../../../shared/components/forms/FormField";
import { Button } from "../../../../shared/components/ui/Button";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import { vm } from "../../../../shared/utils/validationMessages";

// ✅ Validation schema
const formSchema = z.object({
  name: z.string().min(1, { message: vm.NAME_REQUIRED }),
  citizenship_number: z
    .string()
    .trim()
    .min(1, { message: vm.CITIZENSHIP_REQUIRED })
    .regex(/^\d+$/, { message: vm.CITIZENSHIP_DIGITS_ONLY })
    .min(6, { message: vm.CITIZENSHIP_LENGTH })
    .max(10, { message: vm.CITIZENSHIP_LENGTH }),
});

export type CreateUserFormValues = z.infer<typeof formSchema>;

interface CreateUserFormProps {
  defaultValues: CreateUserFormValues;
  onSubmit: (data: CreateUserFormValues) => void;
  onCancel?: () => void;
  isSubmitting?: boolean;
}

export const CreateUserForm: React.FC<CreateUserFormProps> = ({
  defaultValues,
  onSubmit,
  onCancel,
  isSubmitting,
}) => {
  const form = useForm<CreateUserFormValues>({
    resolver: zodResolver(formSchema),
    mode: "onChange",
    defaultValues,
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = form;

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex flex-col gap-5 w-full max-w-md mx-auto"
    >
      {/* Nombre */}
      <FormField
        type="input"
        label="Nombre"
        required
        inputProps={{
          type: "text",
          placeholder: "Nombre del usuario",
          ...register("name"),
        }}
        error={errors.name?.message}
      />

      {/* Cédula */}
      <FormField
        type="input"
        label="Cédula de ciudadanía"
        required
        inputProps={{
          type: "text",
          placeholder: "Cédula de ciudadanía",
          ...register("citizenship_number"),
        }}
        error={errors.citizenship_number?.message}
      />

      {/* Buttons */}
      <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 mt-2">
        {onCancel && (
          <Button
            type="button"
            variant="secondary"
            onClick={onCancel}
            disabled={isSubmitting}
            className="text-sm px-4"
          >
            Cancelar
          </Button>
        )}
        <Button
          type="submit"
          disabled={!isValid || isSubmitting}
          className="text-sm px-4"
        >
          {isSubmitting ? "Guardando..." : "Guardar"}
        </Button>
      </div>
    </form>
  );
};

